// extracted by mini-css-extract-plugin
export var deleteModal = "_qu-0";